import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { EnrollmentViewModel } from '../../../models/enrollment-view-model'
import { EnrollmentGateway } from '../../../gateways/enrollment-gateway'
import { SetEnrollmentDataPdf } from '../../../models/set-enrollment-data-pdf'
import { EnrollmentData } from '../../../models/enrollment-data'
import { PortalGlobals } from '../../../../portalglobals'
import { Title } from '@angular/platform-browser'

@Component({
    selector: 'NEJESingleGroupStep5',
    templateUrl: 'single-group-step5.component.html'
})
export class NEJESingleGroupStep5Component implements OnInit {
    enrollment: EnrollmentViewModel = {} as EnrollmentViewModel
    confirmationNumber: string
    showUpdatesSettingsMessage = 'Success'
    setPdf: SetEnrollmentDataPdf = {} as SetEnrollmentDataPdf
    enrollmentJson: EnrollmentData
    selectedPlanYear: number
    baseTitle: string

    constructor(private router: Router, private _enrollementGateway: EnrollmentGateway, public _global: PortalGlobals, private titleService: Title) {
        this.enrollment = {} as EnrollmentViewModel
        this.setPdf = {} as SetEnrollmentDataPdf
    }

    ngOnDestroy(): void {
        this.titleService.setTitle(this.baseTitle)
    }

    ngOnInit() {
        // Set unique title
        this.baseTitle = this.titleService.getTitle();
        this.titleService.setTitle(this.baseTitle + ' - Confirmation')
        this.enrollment = this._enrollementGateway.getEnrollmentViewModel()
        sessionStorage.setItem('enrollmentViewModel', JSON.stringify(this.enrollment))
        localStorage.setItem('enrollmentViewModel', JSON.stringify(this.enrollment))

        var User = localStorage.getItem('UserSessionContext')
        this._global.currentUser = JSON.parse(User!)

        if (this.enrollment !== undefined && this.enrollment.CONF !== undefined) {
            this.confirmationNumber = this.enrollment.CONF
        }

        //Remove session object for enrollment cache
        if (sessionStorage.getItem('EnrollmentCache') != null) {
            sessionStorage.removeItem('EnrollmentCache')
        }

        //  if (this.enrollment !== undefined && this.enrollment !== null) { this.SendEmailOnConfirmation(this.enrollment.PLANTYPENAME) }
    }

    enrollNew(): void {
        this.enrollment = {} as EnrollmentViewModel
        this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/neje/single-group/Step1'])
    }

    SendEmailOnConfirmation(planname: string): void {
        this._enrollementGateway.SendEmailOnConfirmation(planname).subscribe(() => (this.showUpdatesSettingsMessage = 'Success'))
    }

    SavePdf(): void {
        //if (this.enrollment.EOB !== undefined) {
        //    if (this.enrollment.EOB.toString().toUpperCase() === 'EEOB') {
        //        this.enrollment.EOB = 'Yes'
        //    } else {
        //        this.enrollment.EOB = 'No'
        //    }
        //}
        //else {
        //    this.enrollment.EOB = ''
        //}
        if (this._global.selectedPlanYear !== undefined && this._global.selectedPlanYear !== null)
            this.selectedPlanYear = this._global.selectedPlanYear
        else this.selectedPlanYear = 2021

        this._enrollementGateway
            .generatePDF(this.enrollment, this._global.currentUser.insuranceCompanyName, this.selectedPlanYear)
            .subscribe((model: any) => {
                console.log(model)
                var binaryString = window.atob(model)
                var binaryLen = binaryString.length
                console.log('binaryLen' + binaryLen)
                if (binaryLen == 3) {
                    console.log('File doesnt exist / some back ground  error')
                    // this.downloadError = 'File Not Found'
                    return
                }
                // this.downloadError = ''
                var bytes = new Uint8Array(binaryLen)
                for (var i = 0; i < binaryLen; i++) {
                    var ascii = binaryString.charCodeAt(i)
                    bytes[i] = ascii
                }

                let fileName = this.enrollment.APPLN + '-' + this.enrollment.APPFN + '.pdf'
                // below code needed for ie browser
                if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
                    ;(window.navigator as any).msSaveBlob(new Blob([bytes], { type: 'application/pdf' }), fileName)
                }
                // for other browsers
                var fileURL = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }))
                // window.open(fileURL)
                var link = document.createElement('a')
                link.setAttribute('href', fileURL)
                link.setAttribute('download', fileName)
                link.style.display = 'none'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            })
    }
}
